// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(/css/effectorGenes.css);"]);
// Module
exports.push([module.id, "\nlabel[data-v-a41a20b8] {\n    margin: 10px;\n}\n.pigean-subtable[data-v-a41a20b8] {\n    font-size: smaller;\n    margin-left: 15px;\n    background-color: #efefef;\n}\n.pigean-subtable .row .col-12[data-v-a41a20b8] {\n    padding: 0 0 0 5px !important;\n}\nul.top-list[data-v-a41a20b8] {\n    font-size: 0.8rem;\n}\n.wrapped-cell-content[data-v-a41a20b8] {\n    word-wrap: break-word;\n    word-break: break-word;\n    white-space: normal;\n    max-width: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
